import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Loading } from "../../components";
import { ENGAGE_GET_CREDIT_SESSION } from "../../constants";
import { validateEngageFirst } from "../../services/ads/ads.service";
import { links } from "../../constants/links";


const VALIDATE_ENGAGE_FIRST = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const engageFirstSessionId = location.pathname.split("/")[2];

  useEffect(() => {
    if (engageFirstSessionId) {
      localStorage.setItem(ENGAGE_GET_CREDIT_SESSION, engageFirstSessionId);
      validateEngageFirst(engageFirstSessionId).then((res) => {
        const redirect_url: string = res?.data?.redirect_url;
        const background = res?.data?.background;
        const banner_image_corner = res?.data?.banner_image_corner;
        const url_string = redirect_url.split("/");
        if (url_string[4] === "success") {
          const platformName = redirect_url.split("platform=")[1];
          return navigate(
            `${links.CAMPAIGN_STATUS.replace(":status", "success")}?platform=${platformName}`,
            {
              state: {
                background,
                banner_image_corner,
              }
            }
          );
        } else {
          return window.location.href = redirect_url;
        }
      }).catch(() => {
        navigate(`${links.SMART_RETAIL_ERROR}?error-msg=campaign_error`);
      });
    } else {
      navigate(`${links.SMART_RETAIL_ERROR}?error-msg=campaign_error`);
    }
  }, [navigate, engageFirstSessionId]);

  return (
    <>
      <Loading />
    </>
  );
};

export default VALIDATE_ENGAGE_FIRST;
